class unlockGift extends HTMLElement {
  constructor() {
    super();
    this.btnAddGift = this.querySelectorAll('.btn-add-gift');
    this.cart =
      document.querySelector('cart-notification') ||
      document.querySelector('cart-items') ||
      document.querySelector('cart-drawer');

    this.addEventAddGiftToCart(this);
  }

  addEventAddGiftToCart(self) {
    self.btnAddGift.forEach((btn) => {
      btn.addEventListener('click', function () {
        let unlock_threshold = parseFloat(btn.getAttribute('data-unlock_threshold'));

        //Check threshold validate
        let productCard = btn.closest('.product-card-option');
        let notification = productCard.querySelector('.notification');
        let totalPriceInCart = 0;

        if (window.page != 'cart') {
          if (document.querySelector('.totals__subtotal-value')) {
            totalPriceInCart = parseFloat(
              document.querySelector('.totals__subtotal-value')?.getAttribute('data-total-cart')
            );
          }
        } else {
          if (
            document
              .getElementById('main-cart-footer')
              .querySelector('.totals__subtotal-value-cart-page')
              ?.getAttribute('data-total-cart')
          ) {
            totalPriceInCart = parseFloat(
              document
                .getElementById('main-cart-footer')
                .querySelector('.totals__subtotal-value-cart-page')
                ?.getAttribute('data-total-cart')
            );
          }
        }

        if (unlock_threshold > totalPriceInCart) {
          self.showNotification(notification, window.translate.add_error_gift, 'error');
        } else {
          self.clearNotification(notification);
          self.addGiftToCart(self, productCard);
        }
      });
    });
  }

  showNotification(notification, mess, classNotification) {
    this.clearNotification(notification);

    notification.classList.add(classNotification);
    notification.innerHTML = mess;
  }

  clearNotification(notification) {
    notification.innerHTML = '';
    notification.className = 'notification';
  }

  addGiftToCart(self, productCard) {
    let idGift = productCard.querySelector('.id-gift-add-cart').value;
    let idProduct = productCard.querySelector('.product-id').value;

    productCard.querySelector('.btn-add-gift').classList.add('loading');
    productCard.querySelector('.loading-overlay__spinner').classList.remove('hidden');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData();

    formData.append('id', idGift);
    formData.append('product-id', idProduct);
    formData.append('quantity', 1);
    formData.append('properties[_product_free]', 'true');

    if (this.cart) {
      formData.append('sections_url', window.location.pathname);
      if (window.page != 'cart') {
        self.cart.setActiveElement(document.activeElement);
        formData.append(
          'sections',
          this.cart.getSectionsToRender().map((section) => section.id)
        );
      } else {
        formData.append(
          'sections',
          this.cart.getSectionsToRender().map((section) => section.section)
        );
      }
    }

    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          return;
        } else if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }
        const parsedState = response;
        if (window.page != 'cart') {
          self.cart.renderContents(response);
        } else {
          this.cart.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) ||
              document.getElementById(section.id);

            if (elementToReplace && parsedState.sections[section.section]) {
              elementToReplace.innerHTML = this.cart.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );
            }
          });
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        if (self.cart && self.cart.classList.contains('is-empty')) self.cart.classList.remove('is-empty');
        productCard.querySelector('.btn-add-gift').classList.remove('loading');
        productCard.querySelector('.loading-overlay__spinner').classList.add('hidden');

        productCard.querySelector('.btn-add-gift ').classList.add('hidden');
        if (productCard.querySelector('.mess-has-add-to-cart')) {
          productCard.querySelector('.mess-has-add-to-cart').classList.remove('hidden');
        }
      });
  }
}
customElements.define('unlock-gift', unlockGift);
